import { styled } from 'mz-ui-kit'

export const LoadMoreWrapper = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '40px',
})
